<h2 class="text-center text-md-start" >Nossos parceiros</h2>
<hr>
<section class="swiper">
  <swiper-container init="false" #partnersSwiper>
    @for (partner of partners; track partner.name) {
      <swiper-slide class="swiper-slide" lazy="true">
          <img  [src]="partner.src" [alt]="partner.name + 'partner'" loading="lazy">
      </swiper-slide>
    }
  </swiper-container>
  <div class="swiper-pagination"></div>
</section>
